import { render, staticRenderFns } from "./CustomerTradeIn.vue?vue&type=template&id=5e6e37cb&scoped=true"
import script from "./CustomerTradeIn.vue?vue&type=script&lang=js"
export * from "./CustomerTradeIn.vue?vue&type=script&lang=js"
import style0 from "./CustomerTradeIn.vue?vue&type=style&index=0&id=5e6e37cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6e37cb",
  null
  
)

export default component.exports